import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { HelperProvider } from 'src/app/providers/helper.provider';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-support-ticket',
  templateUrl: './support-ticket.page.html',
  styleUrls: ['./support-ticket.page.scss'],
})
export class SupportTicketPage implements OnInit {

  @Input() data: any;

  reqBody: any = {
    topic: "support"
  }
  constructor(
    private modalController: ModalController,
    private helperProvider: HelperProvider,
    private translationService: TranslateService
  ) { }

  ngOnInit() {
  }

  goBack() {
    this.modalController.dismiss();
  }

  saveAndRefresh() {
    this.modalController.dismiss({ refresh: true });
  }

  async send() {
    if (!this.reqBody.subject || !this.reqBody.message || !this.reqBody.topic) {
      return this.helperProvider.showAlert(this.translationService.instant("record.error"), this.translationService.instant("record.all_fields_are_required"));
    }
    try {
      await this.helperProvider.startLoading();
      await this.helperProvider.getMyData({ officeId: environment.SEPTIC_OFFICE_ID, regId: environment.SUPPORT_REQ_REG_ID, sensorId: this.data._id, type: "actionClick", actionType: "createRecord", ...this.reqBody });
      await this.helperProvider.closeLoading();
      // this.helperProvider.showToast(`Raised requests for support!`);
      this.translationService.instant("record.request_raised_success")
      this.saveAndRefresh();
    } catch (error) {
      this.helperProvider.showAlert(this.translationService.instant("record.error"), error);
      await this.helperProvider.closeLoading();
    }
  }

}
